import { saveAs } from "file-saver";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import ExcelApi from "../../../api/excel.api";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import ExcelBtn from "../../../component/atoms/button/excelBtn";
import Checkbox from "../../../component/atoms/input/checkbox";
import SearchBar from "../../../component/atoms/input/searchBar";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Table from "../../../component/atoms/layout/table/table";
import TableFilter from "../../../component/atoms/layout/table/tableFilter";
import TableLayout from "../../../component/atoms/layout/table/tableLayout";
import TableSearchBtn from "../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import PretendardText from "../../../component/atoms/text/pretendardText";
import TableText from "../../../component/atoms/text/table/tableText";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Pagination from "../../../component/molecules/pagination";
import TableCount from "../../../component/molecules/tableCount";
import TableTopFilter from "../../../component/molecules/tableTopFilter";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import TableTab02 from "../../../component/molecules/tableTab02";
import PayApi from "../../../api/pay.api";
import { toastMsg } from "../../../util/toastMsg";
import Modal from "../../../component/templates/Modal";

const Subscribe = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const pageList = [
    {
      title: "구독 내역",
      link: route.payment_subscribe_list,
      originLink: route.payment_subscribe_list,
    },
    {
      title: "구독 관리",
      link: route.payment_subscribe_setting,
      originLink: route.payment_subscribe_setting,
    },
  ];

  const tabList = [{ title: "전체" }, { title: "구독중" }, { title: "구독해지" }];

  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    setTab(searchParams.get("tab") ? searchParams.get("tab") : "1");
    getPayList();
  }, [location]);

  const [payList, setPayList] = useState([1]);
  const [keyword, setKeyword] = useState("");
  const [tab, setTab] = useState("");

  const getPayList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
        membershipStatus: searchParams.get("tab") === "2" ? "ING" : searchParams.get("tab") === "3" ? "CANCEL" : undefined,
      };
      let responseData = (await PayApi.getMembershipList(data)).data.data;
      setPayList(
        responseData.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 목록 가져오기
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  // ----- 활성/비활성
  const [filterOpen, setFilterOpen] = useState(-1);
  const [activationId, setActivationId] = useState(null);
  const [activation, setActivation] = useState(null);
  const [activationModalTitle, setActivationModalTitle] = useState("");
  const [activationModalOpen, setActivationModalOpen] = useState(false);

  const activationFunc = async () => {
    try {
      const data = {
        membershipStatus: activation,
      };
      await PayApi.updateMembershipStatus(activationId, data);
      toast(toastMsg.create);
      setFilterOpen(-1);
      setActivationModalOpen(false);
      getPayList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>구독 관리</TableTitle>
          <TableTab02 list={pageList} style={{ marginBottom: "10px" }} />
          <TableTopFilter route={route.payment_subscribe_list} tabList={tabList} />
          <TableTop>
            <TableCount text={"항목"} count={pagination.totalCount} />
            <TableSearchBtn>
              <SearchBar
                placeholder={"검색어를 입력하세요"}
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(`${route.payment_subscribe_list}?page=1&keyword=${encodeURIComponent(keyword)}&tab=${tab}`, {
                      replace: true,
                    });
                  }
                }}
                onClick={() => {
                  navigate(`${route.payment_subscribe_list}?page=1&keyword=${encodeURIComponent(keyword)}&tab=${tab}`, {
                    replace: true,
                  });
                }}
              />
            </TableSearchBtn>
          </TableTop>
          <Table>
            <colgroup>
              {/* 상태 */}
              <col width={"160px"} />
              {/* 아이디 */}
              <col width={"87px"} />
              {/* 이름 */}
              <col width={"329px"} />
              {/* 결제일자 */}
              <col width={"150px"} />
              {/* 구독기간 */}
              <col width={"242px"} />
              {/* 상세보기 */}
              <col width={"73px"} />
            </colgroup>
            <thead>
              <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "40px" }}>
                  <TableText>{"상태"}</TableText>
                </Th>
                <Th>
                  <TableText>{"아이디"}</TableText>
                </Th>
                <Th>
                  <TableText>{"이름"}</TableText>
                </Th>
                <Th>
                  <TableText>{"결제일자"}</TableText>
                </Th>
                <Th>
                  <TableText>{"구독기간"}</TableText>
                </Th>
                <Th>
                  <TableText>{"상세보기"}</TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {payList.map((item, index) => {
                return (
                  <Tr key={index} style={{ height: "59px", background: "#fff" }}>
                    <Td style={{ paddingLeft: "40px" }}>
                      <TableFilter
                        style={{
                          width: "87px",
                        }}
                        onClick={() => {
                          filterOpen === index ? setFilterOpen(-1) : setFilterOpen(index);
                        }}
                        isOpen={filterOpen === index}
                        selectedValue={item.membershipStatus}
                        list={[
                          {
                            value: "ING",
                            title: "구독중",
                            onClick: () => {
                              toast("구독중으로 변경은 불가합니다.");
                              return;
                            },
                          },
                          // {
                          //   value: "END",
                          //   title: "구독종료",
                          //   onClick: () => {
                          //     setActivationId(item.id);
                          //     setActivation("END");
                          //     setActivationModalTitle("구독종료");
                          //     setActivationModalOpen(true);
                          //   },
                          // },
                          {
                            value: "CANCEL",
                            title: "구독해지",
                            onClick: () => {
                              setActivationId(item.id);
                              setActivation("CANCEL");
                              setActivationModalTitle("구독해지");
                              setActivationModalOpen(true);
                            },
                          },
                        ]}
                      />
                    </Td>
                    <Td>
                      <TableText>{item.member?.account}</TableText>
                    </Td>
                    <Td>
                      <TableText>{item.member?.name}</TableText>
                    </Td>
                    <Td>
                      <TableText>{moment(item.startDate).format("YYYY/MM/DD")}</TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.startDate).format("YYYY/MM/DD")} ~ {moment(item.endDate).format("YYYY/MM/DD")}
                      </TableText>
                    </Td>

                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(route.payment_subscribe_detail + `/${item.id}`);
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.payment_subscribe_list}
            queryString={`keyword=${encodeURIComponent(searchParams.get("keyword") || "")}&tab=${tab}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>

      {activationModalOpen ? (
        <Modal
          title={`${activationModalTitle} 하시겠습니까?`}
          setModalOpen={setActivationModalOpen}
          onClick={() => {
            activationFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default Subscribe;

const AnswerText = styled(PretendardText)`
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: ${(props) => (props.isAnswer ? "#000" : "#004098")};
`;
